<template>
    <div class="card">
        <div class="card-header">
            <h3 class="card-title">Sesión del día {{ sesion ? sesion.fecha  : ''}}</h3>
        </div>

        <div class="card-body" v-if="!loading">
            <transition name="fade" mode="out-in">
                <div class="row" key="1" v-if="paso1" id="paso1">
                    <div class="col-12">
                        <h2 class="m-0 h1 text-uppercase">Selecciona tus entradas</h2>
                    </div>

                    <div class="col-md-12 col-lg-8">
                        <transition name="fade" mode="out-in">
                            <div class="row" v-if="!loading" key="mapa-butacas" id="mapa-butacas">
                                <div class="col-lg-12" style="height: 700px">
                                    <MapaGeneralComponent 
                                        :seats="map_seats" 
                                        :recinto="evento.place_obj"
                                        @seleccionar-butaca="seleccionarButaca"
                                        @eliminar-butaca="eliminarButaca"
                                    />
                                </div>    
                            </div>
                            <div class="row" v-else>
                                <div class="col-12 text-center" style="height: 400px">
                                    <LoaderComponent/>
                                </div>
                            </div>                            
                        </transition>
                    </div>
                    <div class="col-md-12 col-lg-4">
                        <TusAsientosComponent :asientos="asientos_seleccionados" :configuracion_valida="puede_continuar" @continuar="bloquearAsientos"/>
                    </div>
                </div>
            </transition>
            <transition name="fade" mode="out-in">
                <div class="row" key="2" v-if="paso2" id="paso2">
                    <div class="col-12">
                        <PasoTresComponent
                            :datos_compradores="asientos_seleccionados"
                            :solicitar_datos="true"
                            @goTo="finalizarPasoTres"
                        />
                    </div>                    
                </div>
            </transition>
            <transition name="fade" mode="out-in">
                <div class="row" key="3" v-if="paso3" id="paso3">
                    <div class="col-12">
                        <PasoCuatroComponent
                            :datos_compra="datos_compra"
                            :email="datos_compra.enviar_email"
                            :whatsapp="datos_compra.enviar_whatsapp"
                            :carrito_id="session_id"
                            :evento="evento"
                            :recinto="evento.place_obj"
                        />
                    </div>                    
                </div>
            </transition>
        </div>

        <div class="card-body" v-else>
            <LoaderComponent/>
        </div>
    </div>
</template>

<script>
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import MapaGeneralComponent from '@/components/recintos/MapaGeneralComponent.vue';
    import TusAsientosComponent from '@/components/backend/stepper/components/TusAsientosComponent.vue';
    import PasoTresComponent from '@/components/backend/stepper/eventos/PasoTresComponent.vue';
    import PasoCuatroComponent from '@/components/backend/stepper/eventos/PasoCuatroComponent.vue';

    export default {
        props: ['evento', 'sesion'],
        data() {
            return {
                loading: false,
                map_seats: [],
                paso1: true,
                paso2: false,
                paso3: false,
                asientos_seleccionados: [],
                session_id: null,
                datos_compra: null
            }
        },
        created() {
            this.getMapaButacas();
        },
        computed: {
            puede_continuar() {
                var continuar = true;
                var seleccionadas = 0;
                var old = 0;

                for (let i = 0; i < this.map_seats.length; i++) {
                    if(this.map_seats[i].status == 'seleccionado') {
                        if(old > 0) {
                            continuar = false;
                            break;
                        }
                        seleccionadas++;
                        old = 0;
                    }
                    
                    if(this.map_seats[i].status == 'disponible') {
                        if(seleccionadas > 0) {
                            old++;
                        }                        
                    }
                    
                }

                return continuar;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        methods: {
            getMapaButacas() {
                this.loading = true;

                const params = {
                    filters: {
                        sesion_id: this.sesion.id,
                        event_id: this.evento.id,
                        taquilla: true
                    },
                    sesion_id: this.sesion.id,
                    event_id: this.evento.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.events.sesion.seats.map'), params).then(res => {
                    this.map_seats = res.data.data;
                }).finally(() => this.loading = false);
            },
            seleccionarButaca(seat) {
                this.asientos_seleccionados.push({
                    asiento: seat,
                    datos: []
                });
            },
            eliminarButaca(seat) {
                this.asientos_seleccionados.forEach(function(element, index, array) {
                    if(element.asiento.region_id == seat.region_id && element.asiento.row == seat.row && element.asiento.seat == seat.seat) {
                        array.splice(index, 1);
                    }
                });
            },
            bloquearAsientos() {
                this.loading = true;

                var seats = [];

                for(var i in this.asientos_seleccionados) {
                    this.asientos_seleccionados[i].asiento.precios.forEach(precio => {
                        if(precio.id == this.asientos_seleccionados[i].asiento.event_ticket_id) {
                            this.asientos_seleccionados[i].precio = precio;
                        } else {
                            this.asientos_seleccionados[i].precio = null;
                        }
                    });

                    this.asientos_seleccionados[i].precios = this.asientos_seleccionados[i].asiento.precios;

                    seats.push(this.asientos_seleccionados[i].asiento);
                }

                const params = {
                    filters: {
                        sesion_id: this.sesion.id,
                        tid: this.configuracion.hash_teatro
                    },
                    asientos: seats,
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                    if(res.data.error) {
                        this.$toast.error(res.data.message);
                    } else {
                        this.session_id = res.data.session_id;
                        this.loading = false;
                        this.paso2 = true;
                        this.$nextTick(function() {
                            this.scrollTo('#paso2');
                        });
                    }                    
                }).catch(error => {
                    this.$toast.error('Esta BUTACA ya ha sido seleccionada, por  favor, selecciona otra butaca. ');
                    console.log(error);
                    this.loading = false;
                });
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            finalizarPasoTres(paso, datos, email, whatsapp) {
                var datos_compra = null;

                datos_compra = {
                    evento_id : this.evento.id,
                    sesion_id : this.sesion.id,
                    datos_compradores : this.asientos_seleccionados,
                    metodo_pago : datos.metodo_pago,
                    modalidad : 0,
                    tipo : false,
                    concepto : datos.concepto,
                    enviar_email : datos.enviar_email,
                    email : datos.email,
                    nombre : datos.nombre,
                    telefono : datos.telefono,
                    enviar_whatsapp : datos.enviar_whatsapp,
                    cp: datos.cp,
                    recinto: true
                };

                if(datos) {
                    this.datos_compra = datos_compra;
                }

                this.paso3 = true;

                this.$nextTick(function() {
                    this.scrollTo('#paso' + paso);
                });
            }
        },
        components: {
            LoaderComponent, MapaGeneralComponent, TusAsientosComponent, PasoTresComponent, PasoCuatroComponent
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
